import React from 'react';
import { Handle, Position } from 'reactflow';
import { File, FileImage, FileText, FileCode, X } from 'lucide-react';

function fileIcon(mimeType = '') {
  if (mimeType.startsWith('image/')) return <FileImage size={16} />;
  if (mimeType.startsWith('text/') || mimeType.includes('pdf')) return <FileText size={16} />;
  if (mimeType.includes('json') || mimeType.includes('javascript') || mimeType.includes('python')) return <FileCode size={16} />;
  return <File size={16} />;
}

function fmtSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const FileNode = ({ data }) => {
  return (
    <div className="file-node">
      <div className="tool-node-controls">
        <button
          className="delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            data.onDelete && data.onDelete();
          }}
        >
          <X size={11} />
        </button>
      </div>

      <Handle type="target" position={Position.Top} style={{ backgroundColor: '#10b981' }} />

      <div className="file-node-icon">{fileIcon(data.mime_type)}</div>
      <div className="file-node-name">{data.filename || data.title || 'File'}</div>
      {data.file_size && (
        <div className="file-node-meta">{fmtSize(data.file_size)}</div>
      )}

      <Handle type="source" position={Position.Bottom} style={{ backgroundColor: '#10b981' }} />
    </div>
  );
};

export default FileNode;
